import { TypeOf, yup } from '@guiker/yup-util'

export const assetSchema = yup
  .object({
    id: yup.string().required(),
  })
  .required()

export type AssetSchema = TypeOf<typeof assetSchema>
